import imgBenefit1 from 'assets/img/stake_benefit_1.png';
import imgBenefit2 from 'assets/img/stake_benefit_2.png';
import imgBenefit3 from 'assets/img/stake_benefit_3.png';
export const benefitOptions = [{
  title: 'APR up to',
  remarkable: '240%',
  info: 'High return with multiple staking options',
  imgSrc: imgBenefit1
}, {
  title: 'Opportunities to join',
  remarkable: 'Private Sale',
  info: 'Easy access to private investment rounds with attractive profit ',
  imgSrc: imgBenefit2
}, {
  title: 'Increase the value of',
  remarkable: 'Your Assets & THG',
  info: 'Contribution to the sustainable growth of Thetan Arena’s tokenomics',
  imgSrc: imgBenefit3
}];